import HakAksesDashboard from './HakAksesDashboard';

export default HakAksesDashboard;
